import doesAgendaItemStartWithinNextHour from './doesAgendaItemStartWithinNextHour';
import getIsAgendaItemCurrentlyLive from './getIsAgendaItemCurrentlyLive';

export default (items = []) => {
  const agendaItemsInNextHourOrLive = items.filter((agendaItem) => {
    return (
      doesAgendaItemStartWithinNextHour({ agendaItem }) ||
      getIsAgendaItemCurrentlyLive({ agendaItem })
    );
  });

  return agendaItemsInNextHourOrLive[0];
};
